<template>
  <div class="gkmg-port-master-dialog-text-and-number-input">
    <div class="flex justify-center">
      <span class="text-before-change max-w-full">
        変更前 : {{ valueMap.itSelf }}
      </span>
    </div>

    <div class="flex justify-center">
      <input class="input" v-model="inputValue" />
    </div>

    <div class="flex justify-center">
      <vs-button class="button" color="#2E87B9" @mousedown="closePopup">
        <span class="button-text">キャンセル</span>
      </vs-button>
      <vs-button
        class="button"
        color="#2E87B0"
        @mousedown="onSubmit(isUpdateTimeStamp)"
      >
        <span class="button-text">保存</span>
      </vs-button>
    </div>
  </div>
</template>

<script>
/*
 * 入出港予定一覧画面（白色ではなく黒色画面）のセル編集にあたり、テキスト編集をする場合のためのコンポーネント
 * @parent CellSummaryDialog.vue
 * @props taskId: String 一覧画面で表示する一行のデータにふられたID
 *        columnKey: String カラム名を特定するためのキー。const.jsのCOL_NAMEの中の、columnKey
 *        valueMap : String 現在表示されている値。
 */
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("gkmgPortMasterDestinationWork");
import moment from "moment-timezone";
import { COL_NAME } from "../../../config/const";

export default {
  name: "O.DialogTextInput",
  props: {
    taskId: { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap: { type: Object, required: true },
    closePopup: { type: Function, required: true },
    inputType: { type: String, required: true },
  },
  data() {
    return {
      inputValue: "",
      isUpdateTimeStamp: null,
    };
  },
  watch: {
    summaryDialogShowPopup() {
      if (this.summaryDialogShowPopup === true) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: (state) => state.masterMap,
      summaryDialogShowPopup: (state) => state.summaryDialogShowPopup,
    }),
    enableSave() {
      return true;
    },
  },
  methods: {
    initData() {
      this.inputValue = this.valueMap.itSelf ? this.valueMap.itSelf : "";
      this.isUpdateTimeStamp =
        this.inputValue ||
        (this.valueMap.changes && this.valueMap.changes[String(this.columnKey)])
          ? true
          : false;
    },
    onSubmit(isUpdateTimeStamp) {
      /*
       * onSubmit(false)    : 保存
       * onSubmit(true)     : ハイライト保存
       */

      const displayType = COL_NAME.find(
        (el) => el.columnKey === this.columnKey,
      ).displayType;
      if (displayType === "plain-number") {
        if (isNaN(Number(this.inputValue))) {
          this.$vs.notify({
            title: "不正なデータです。",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
          return;
        }
        this.inputValue =
          this.inputValue !== "" ? Number(this.inputValue) : null;
      }

      let mode = [];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp");
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] =
        this.inputValue || this.inputValue === 0 ? this.inputValue : null;
      updateKeyValueMap["updated_at"] = new Date(
        moment().local().format("YYYY-MM-DD HH:mm:ss"),
      );
      this.$emit("updateValue", this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style scoped lang="scss">
.gkmg-port-master-dialog-text-and-number-input {
  .text-before-change {
    /* text */

    width: 761px;
    height: 24px;

    font-family: "Hiragino Kaku Gothic Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height */
    display: flex;
    align-items: center;
    text-align: center;

    color: #4f4f4f;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .input {
    width: 761px;
    border-radius: 8px;
    padding: 16px 0px 16px 0px;
    margin: 16px 0px 16px 0px;
    gap: 8px;

    font-family: "Hiragino Kaku Gothic Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #4f4f4f;
    background-color: #bcbcbc;
    border: none;
  }

  .button {
    width: 230px;
    height: 46px;
    margin: 0 1rem;
    border-radius: 8px;
    cursor: pointer;
  }
  .button-text {
    width: 32px;
    height: 24px;

    font-family: "Hiragino Kaku Gothic Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height */
    align-items: center;
    text-align: center;

    color: #f2f2f2;
  }
}
</style>
